import { BigNumber } from '@ethersproject/bignumber';
import { PropsBase } from '../model/props-base';
import { CryptoValue } from './crypto-value.component';

export interface AuctionPriceProps extends PropsBase {
    value?: number | BigNumber;
}

export function AuctionPrice(props: AuctionPriceProps) {
    const value = props.value || 0;

    return (
        <div {...props} title={value.toString()}>
            <CryptoValue className="text-avenir-ul h1 mb-0" value={value} />
            <span className="mb-0 text-avenir-re text-themed h5">
                <span className="ms-2">CURRENT BID</span>
            </span>
        </div>
    );
}